var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('head-title',{attrs:{"title":_vm.$slots.default[0].text}}),_vm._v(" "),_c('div',{staticClass:"text-h5 text--secondary mb-2"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }